import React from 'react';
import { MainTemplate } from 'shared/MainTemplate/MainTemplate';

export const ShopPage: React.FC = () => {
	return <MainTemplate title='Магазин'></MainTemplate>;
};
